import { ParagraphS } from "@components/Typography"
import styled, { css } from "styled-components"
import { Variant, Style } from "./"

export const AnchorStyle = styled(ParagraphS)<{
  variant?: Variant
  styling?: Style
}>`
  cursor: pointer;
  color: ${(p) => p.theme.colors.text.light};
  transition: color 0.2s ease-in-out;
  display: flex;
  align-items: center;
  text-decoration: none;

  svg {
    fill: currentColor;
    width: 1rem;
    height: 1rem;
    transition: transform 0.2s ease-in-out;
    ${(p) =>
      p.variant === "arrow-left"
        ? css`
            margin-right: 0.5rem;
          `
        : css`
            margin-left: 0.5rem;
          `};
  }

  &:hover {
    color: ${(p) => p.theme.colors.text.dark};
    svg {
      ${(p) =>
        p.variant === "arrow-right"
          ? css`
              transform: translateX(0.25rem);
            `
          : css`
              transform: translateX(-0.25rem);
            `}
    }
  }

  ${(p) =>
    p.styling &&
    css`
      text-transform: uppercase;
      color: ${(p) => p.theme.colors.purple};
      letter-spacing: 2px;
    `}
`

export const Anchor = AnchorStyle.withComponent("a")
